import { useStore } from '@nanostores/react';
import { Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { store } from './state';
import { OSInfoLog } from '../../api/type';
import { DateTime } from 'luxon';

const actionColumns: ColumnsType<OSInfoLog> = [
  {
    title: '日期',
    dataIndex: 'date',
    key: 'date',
    render(value) {
      return DateTime.fromISO(value).toFormat('yyyy-MM-dd HH:mm:ss');
    },
  },
  {
    title: 'IP 信息',
    dataIndex: 'ipInfo',
    key: 'ipInfo',
    render(_, record) {
      // Assuming IP info is part of the data, adjust as necessary
      if (!record.data.ip) {
        return <div>未知</div>;
      }
      return (
        <div>
          <div>{record.data.ip}</div>
          <div>
            {record.data.ip_location.region} {record.data.ip_location.city} - {record.data.ip_location.isp}
          </div>
        </div>
      );
    },
  },
  {
    title: '系统配置',
    dataIndex: 'systemConfig',
    key: 'systemConfig',
    render(_, record) {
      return (
        <div>
          <div>{record.data.platform}</div>
          <div>{record.data.platform_version}</div>
          <div>
            {record.data.cpu} / 内存{(record.data.memory / 1024).toFixed(1)}G
          </div>
          {record.data.gpu_list.map((gpu, index) => (
            <div key={index}>
              GPU: {gpu.name} (驱动版本: {gpu.driver_version})
            </div>
          ))}
        </div>
      );
    },
  },
  {
    title: '机器标识',
    dataIndex: 'uuid',
    key: 'uuid',
    render(_, record) {
      return (
        <div>
          <div>系统标识 : {record.data.uuid_os}</div>
          <div>硬件标识 : {record.data.uuid_hardware}</div>
          {record.data.gpu_list.map((gpu, index) => (
            <div key={index}>GPU设备ID : {gpu.pnp_device_id}</div>
          ))}
        </div>
      );
    },
  },
];

export function DeviceHistory() {
  const state = useStore(store);

  return (
    <div>
      <div style={{ margin: '24px 0', textAlign: 'left' }}>
        <span style={{ display: 'inline-block' }}>登录历史信息</span>
      </div>
      <Table dataSource={state.deviceLogs} columns={actionColumns} />
    </div>
  );
}
